<mat-icon [ngStyle]="{ '--size': size() + 'px', 'font-weight': fontWeight() }" class="text-current">
    {{ icon() }}
</mat-icon>
